import { Component } from "@angular/core";

import { TrainingProgramService } from './services/trainingprogram.service';

import { ITrainingProgram, ITrainingProgramActivity } from './models/trainingprogram';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  templateUrl: './trainingprogram-list.component.html',
  providers: [TrainingProgramService],
  styles: [`.img-max { max-width: 200px; margin-right: 1rem; margin-bottom: 0rem } `, `.img-min { width: 150px; height: 85px; margin-right: 1rem; border: 1px solid #b74900 } `,
           `.img-thumbnail { max-width: 100%; margin-right: 1rem; margin-bottom: 0rem } `]

})
export class TrainingProgramListComponent {

  programs: ITrainingProgram[] = [];
  selectedProgram: ITrainingProgram;
  selectedActivity: ITrainingProgramActivity;

  programId: number = 0;
  activityId: number = 0;

  mode: string = 'list';

  constructor(private _trainingProgramService: TrainingProgramService, private _route: ActivatedRoute,
              private _router: Router) { }

  ngOnInit() {

    this.programId = +this._route.snapshot.paramMap.get("programId");
    this.activityId = +this._route.snapshot.paramMap.get("activityId");

    this.getPrograms();

  }

  getPrograms() {

    this._trainingProgramService.getTrainingPrograms().subscribe(programs => {
      console.log('programs', programs)
      this.programs = programs;

      this.setProgramActivity(this.programId, this.activityId);
    });
  }

  setProgramActivity(programId: number, activityId: number = 0) {

    if (programId > 0) {
      this.selectedProgram = this.programs.filter(f => f.id == programId)[0];

      if (this.selectedProgram == null) {
        this.mode = 'list';

        programId = 0;
        activityId = 0;
      } else {
        this.mode = 'details';
        this.programId = programId;
      }

      
      if (activityId > 0) {
        this.selectedActivity = this.selectedProgram.activities.filter(f => f.id == activityId)[0];
        if (this.selectedActivity != null) {
          this.mode = 'activity';
        } else {
          return this.setProgramActivity(this.programId);
        }

        this.activityId = activityId;
      }

      var url = "/" + (programId <= 0 ? "" : programId.toString() + (activityId <= 0 ? "" : "/" + activityId.toString()));

      console.log(`trainingprograms${url}`);

      this._router.navigate([`trainingprograms${url}`]);
    } else {
      this.mode = 'list';
      var url = "/";

      console.log(`trainingprograms${url}`);

      this._router.navigate([`trainingprograms${url}`]);
    }
  }

  canClickNext(): boolean {
    if (this.selectedProgram == null || this.selectedActivity == null) {
      return false;
    }

    //need to determine if there is another activity to click
    var next = this.selectedProgram.activities.indexOf(this.selectedActivity) + 1;

    console.log('next', next);
    console.log('next act', this.selectedProgram.activities[next]);

    if (this.selectedProgram.activities[next] != null)
      return true;

    return false;
  }

  canClickPrev(): boolean {
    if (this.selectedProgram == null || this.selectedActivity == null) {
      return false;
    }

    //need to determine if there is another activity to click
    var prev = this.selectedProgram.activities.indexOf(this.selectedActivity) - 1;

    if (this.selectedProgram.activities[prev] != null)
      return true;

    return false;
  }

  prevBtn() {
    
    var prev = this.selectedProgram.activities.indexOf(this.selectedActivity) - 1;

    var prevAct = this.selectedProgram.activities[prev];

    this.setProgramActivity(this.selectedProgram.id, prevAct.id);
  }

  nextBtn() {
    var next = this.selectedProgram.activities.indexOf(this.selectedActivity) + 1;

    var nextAct = this.selectedProgram.activities[next];

    this.setProgramActivity(this.selectedProgram.id, nextAct.id);
  }

  update(programId: number, activityId: number) {

    var act = this.selectedProgram.activities.filter(f => f.id == activityId)[0];

    this._trainingProgramService.updateTrainingProgram(programId, activityId, act.completed)
      .subscribe(res => {

      }, error => {
        alert('error');
        console.log(error);
      });
  }
}
